import { Inventory } from "@onmo/graphql/graphql";
import BundleAvatarSession from "../BundleAvatarSession/BundleAvatarSession";
import { useStyles } from "./ShopAvatarsInventory.style";
import { useFetchBundlesInventory } from "../../../hooks/resolvers/useShopQuery";
import { useAppDispatch } from "../../../hooks";
import { setOpenBundle } from "../../../slices/shop";

const ShopAvatarsInventory: React.FC = () => {
  const dispatch = useAppDispatch();
  const { bundlesInventoryAvailable } = useFetchBundlesInventory();
  const classes = useStyles();

  const onOpenBundle = (currentBundle: Inventory) => {
    dispatch(setOpenBundle({ openBundle: currentBundle }));
  };

  return (
    <div className={classes.root}>
      {bundlesInventoryAvailable?.map((item: Inventory) => {
        return (
          <BundleAvatarSession
            bundleId={item.id}
            title={item.title}
            onOpenBundle={() => onOpenBundle(item)}
          />
        );
      })}
    </div>
  );
};
export default ShopAvatarsInventory;
